import BotResponseTreeNode from './BotResponseTreeNode';

class DeleteVariableTreeNode {
  variableName: string;

  nextStep: BotResponseTreeNode | null;

  constructor(variableName: string, nextStep: BotResponseTreeNode | null) {
    this.variableName = variableName;
    this.nextStep = nextStep;
  }
}

export default DeleteVariableTreeNode;
